// Demo evidence chain so the console is immediately usable / demonstrable.
import { createRecord } from "./crypto";

const DEMO_INPUTS = [
  {
    payload: JSON.stringify(
      { model: "assistant-generic", prompt: "Summarize mission brief 4WM-alpha", response: "Brief acknowledged. All four mirrors nominal." },
      null,
      2
    ),
    payload_type: "AI Response",
    layer: 5,
    drift_status: "NONE",
    notes: "Baseline AI response captured for provenance.",
  },
  {
    payload: JSON.stringify({ document: "provenance-policy.md", version: "1.0", sha_of_source: "self-asserted" }, null, 2),
    payload_type: "Document",
    layer: 14,
    drift_status: "NONE",
    notes: "Policy document anchored.",
  },
  {
    payload: JSON.stringify({ raw_drift: 2.14, corrected_offset: 0.29, refractive_index_v: 1.0003, latency_ms: 42 }, null, 2),
    payload_type: "Telemetry Object",
    layer: 21,
    drift_status: "WARNING",
    notes: "HCT-3 synthetic telemetry snapshot (SIMULATED).",
    source_tag: "simulated",
  },
  {
    payload: JSON.stringify({ system: "SignalLink AI", status: "OPERATIONAL", mirrors: 4, layers: 33 }, null, 2),
    payload_type: "System State",
    layer: 25,
    drift_status: "NONE",
    notes: "System state snapshot.",
  },
  {
    payload: JSON.stringify({ event: "operator-review", operator: "console-user", outcome: "acknowledged" }, null, 2),
    payload_type: "Digital Event",
    layer: 31,
    drift_status: "NONE",
    notes: "Operator review event.",
  },
];

export async function seedDemo() {
  const records = [];
  let prev = null;
  for (const input of DEMO_INPUTS) {
    const rec = await createRecord(input, prev);
    records.push(rec);
    prev = rec.sha256;
  }
  return records;
}
